<template>
    <div class="pages-routing">
      <a-layout>
        <a-layout-header>
          <kw-common-pc-topbar contentwidth="1280"></kw-common-pc-topbar>
          <div class="head-bar">
            <div class="w-content">
              <div class="serm-logo" @click="toHome">
                <i></i><span>广告产品</span>
              </div>
              <div class="serm-search">
                <div class="search-box">
                    <input type="text" v-model="searchWrod" @keypress="enter" class="searchin" maxlength="30" placeholder="请输入关键字">
                    <button @click="searchBtn">搜索</button>
                </div>
                <p class="sertuij">
                  <span>热门搜索：</span>
                    <ul>
                      <li v-for="(text, index) in hotWords" @click="search(text)" :key=index>
                          {{text}}
                      </li>
                    </ul>
                </p>
              </div>
            </div>
        </div>
         </a-layout-header>
         <a-layout-content>
          <div class="rule-routing">
            <div class="w-content">
              <a-layout>
                <a-layout-sider width="180" class="sideBar-n"><SideBar class="side-bar-layout"></SideBar></a-layout-sider>
                <a-layout-content><router-view></router-view></a-layout-content>
              </a-layout>
              <a-back-top />
            </div>
          </div>
         </a-layout-content>
         <a-layout-footer><kw-common-pc-footbar></kw-common-pc-footbar></a-layout-footer>
      </a-layout>
   </div>
</template>
<script>
import {Layout,BackTop} from 'ant-design-vue'
import SideBar from './components/sideBar/index.vue'
import { mapState, mapActions } from 'vuex'
export default {
  components:{
    SideBar,
    'a-layout':Layout,
    'a-layout-sider':Layout.Sider,
    'a-layout-content':Layout.Content,
    [BackTop.name]:BackTop,
    'a-layout':Layout,
    'a-layout-header':Layout.Header,
    'a-layout-footer':Layout.Footer
  },
  async created() {
    await this.queryAdwordsHotWords()
  },
  computed: {
    ...mapState('adwords',['hotWords']),
    searchWrod: {
      get() {
        return this.$store.state.adwords.searchWord
      },
      set(v) {
        this.$store.commit('adwords/setMutations', {data:v,nameSpace:'searchWord'})
      }
    }
  },
  methods: {
    ...mapActions('adwords',['queryCourseList', 'queryAdwordsHotWords']),
    toHome() {
      location.href = '/pages/home'
    },
    async searchBtn() {
      if (this.$route.name != 'adwordsSearch') {
        this.$router.push({name:'adwordsSearch'})
      }
      let params = {
        'pojo.courseName': this.searchWrod
      }
      await this.queryCourseList(params)
      this.$store.commit('adwords/setMutations', {data:'',nameSpace:'linkCargoryId'})
      this.$store.commit('adwords/setMutations', {data:[],nameSpace:'openKeys'})
      this.$store.commit('adwords/setMutations', {data:1,nameSpace:'page'})
    },
    enter(e){
      const keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        this.searchBtn()
      }
    },
    search(text) {
      this.searchWrod = text
      this.searchBtn()
    }
  }
}
</script>

<style lang="scss">
.rule-routing {
  .sideBar-n .ant-layout-sider-children {
    display: flex;
  }
}
</style>

<style lang="scss" scoped>
.pages-routing {
  background-color: #f0f2f5;
  .ant-layout-header {
    background-color: #fff;
    padding: 0;
    height: auto;
    line-height: normal;
    .head-bar {
      height: 100px;
      background-color: #fff;
        .w-content {
          height: 100%;
          display: flex;
          justify-content: space-between;
          padding: 0 30px;
          .serm-logo {
            display: flex;
            align-items: center;
            cursor: pointer;
            i {
              width: 144px;
              height: 48px;
              background: url('~@assets/logo.png') no-repeat;
              background-size: 100% auto;
            }
            span {
              font-size: 20px;
              color: #333333;
              position: relative;
              padding-left: 10px;
              margin-top: 8px;
            }
          }
          .serm-search {
            width: 530px;
            padding-top: 30px;
            .search-box {
              width: 100%;
              background-color: #1C7AE5;
              display: flex;
              height: 38px;
              input {
                width: 450px;
                background-color: #fff;
                margin: 2px;
                height: 34px;
                line-height: 34px;
                border: 0;
                padding: 0 12px;
                font-size: 12px;
              }
              button{
                flex-grow:1;
                border: 0;
                background-color: transparent;
                cursor: pointer;
                font-size: 16px;
                line-height: 38px;
                color: #FFFFFF;
              }
            }
            .sertuij {
              height: 30px;
              line-height: 30px;
              display: flex;
              >span {
                font-size: 12px;
                color: #666666;
              }
              ul {
                display: flex;
                li {
                  padding-left: 20px;
                  font-size: 12px;
                  color: #FF3A00;
                  cursor: pointer;
                }
              }
            }
          }
      }
    }
  }

  .ant-layout-footer {
    padding: 0;
  }

}

.rule-routing {
  padding-top: 15px;
  .w-content>.ant-layout {
    padding: 0 15px;
  }
  .ant-layout-sider {
    background-color: transparent;
    display: flex;
  }
  .ant-layout-content {
    margin-left: 15px;
  }
  .side-bar-layout {
    flex: 1 1 auto;
  } 
}
</style>


